import layers from '../../layers';
import translate from '../tools/translate';
import Customers from './Customers';
import Retention from './Retention';
import Shapes from './Shapes';
import Stores from './Stores';
import Summary from './Summary';
import api from '../../api';
import environment from '../../environment';
import FuelStation from './FuelStation';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import MulticriteriaAfterSales from './MulticriteriaAfterSales';
import StoresAfterSales from './StoresAfterSales';
import MultiShapeDrawer from './MultiShapeDrawer';
import StoresUnapproved from './StoresUnapproved';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const types = {
    customers: (area) => new Customers(area),
    retention: (area) => new Retention(area),
    stores: (area) => new Stores(area),
    storesUnapproved: (area) => new StoresUnapproved(area),
    shapes: (area) => new Shapes(area),
    fuelStation: (area) => new FuelStation(area),
    multicriteriaAfterSales: (area) => new MulticriteriaAfterSales(area),
    networkAfterSales: (area) => new StoresAfterSales(area),
    multiShapeDrawer: (area) => new MultiShapeDrawer(area),
    default: (area) => new Summary(area),
};

const Factory = (type, area) => {
    const constructor = types[type] || types.default;
    return constructor(area);
};

Factory.getAvailableOptions = () => {
    const selectedAreasLayer = layers.get('SelectedAreas');
    const markedAreaLayer = layers.get('MarkedArea');
    const retentionLayer = layers.get('Retention');

    const permissions = environment.get('FEATURES');

    const options = [
        { value: 'shapes', textProp: 'Summary', visible: selectedAreasLayer.visible() || markedAreaLayer.visible() },
        { value: 'stores', textProp: 'StoresLayer', visible: permissions.Dealerships || permissions.Competitors },
        { value: 'storesUnapproved', textProp: 'UnapprovedStores', visible: permissions.UnapprovedStores },
        { value: 'retention', textProp: 'RetentionLayer', visible: retentionLayer.visible() },
        { value: 'customers', textProp: 'CustomersLayer', visible: permissions.Customers },
        { value: 'fuelStation', textProp: 'FuelStationLayer', visible: permissions.FuelStation },
        {
            value: 'multicriteriaAfterSales',
            textProp: 'MulticriteriaAfterSalesLayer',
            visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.export)
        },
        {
            value: 'networkAfterSales',
            textProp: 'NetworkAfterSalesLayer',
            visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.export && FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.export)
        },
        {
            value: 'multiShapeDrawer',
            textProp: 'AddMoreShapes',
            visible: (environment.get('CONFIG.IS_AFTER_SALES'))
        }
    ];

    const labelWithExport = (textProp) => {
        if (textProp === 'UnapprovedStores') {
            return `${translate('Action.Export')} ${translate('Common.UnapprovedStores')}`;
        }

        return translate(`Common.${textProp}`);
    };

    return options
        .filter(x => x.visible)
        .map(({value, textProp}) => ({value, text: labelWithExport(textProp), type: value}));
};

export default Factory;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/SelectionFactory.js